import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { SelectItem } from 'ariakit/select';
import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';
import { Box } from '../Box/index.js';

// TODO - add active style to selected option in dropdown
const StyledSelectItem = styled(Box).withConfig({
  displayName: "SelectItemAlpha__StyledSelectItem",
  componentId: "sc-wk1lm8-0"
})(["&[data-active-item]{background-color:", ";}"], _ref => {
  let {
    disabled
  } = _ref;
  return disabled ? themeGet('colors.white') : themeGet('colors.itemHovered');
});
/* ======================================= */
/**
 *  @deprecated Please use Select for future implementation
 */
// forwardRef needed when using renderProp pattern in SelectMultiItemAlpha
const SelectItemAlpha = /*#__PURE__*/forwardRef((props, ref) => {
  const _isDisabled = props.isDisabled || props.disabled;
  return (
    /*#__PURE__*/
    // @ts-ignore - for "!important"
    React__default.createElement(StyledSelectItem, _extends({
      ref: ref,
      _active: {
        backgroundColor: _isDisabled ? 'white' : 'itemSelected'
      },
      _disabled: {
        cursor: 'not-allowed',
        color: 'disabled'
      }
      // @ts-ignore - conflicting `as` prop with styled-component
      ,
      as: SelectItem,
      cursor: "pointer",
      disabled: _isDisabled,
      fontSize: {
        base: 'fontSize30',
        md: 'fontSize20'
      },
      lineHeight: {
        base: 'lineHeight30',
        md: 'lineHeight20'
      },
      pointerEvents: "initial !important",
      px: "space50",
      py: "8px"
    }, props))
  );
});

export { SelectItemAlpha };
